import StepController from './step_controller';

export default class extends StepController {
  initialize() {
    this.index = this.firstWithErrors() || 0;
    super.initialize();
  }

  firstWithErrors() {
    return this.stepTargets
      .map((element, elementIndex) => {
        if (element.querySelector('.field_with_errors')) return elementIndex;
        return null;
      })
      .find(Number.isInteger);
  }
}
